import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { ITheme } from 'src/app/interfaces/BFF';
import { IPayloadToken } from 'src/app/interfaces/Global/PayloadToken';
import { IInspectionOrder } from 'src/app/interfaces/Outputs';
import { ISummary, ISummaryScreen } from 'src/app/interfaces/Outputs/Summary';

@Injectable({
  providedIn: 'root'
})
export class StylesService {

  constructor() { }

  // TODO: Crear un método para los estilos devueltos por cada pantalla

  async saveAppTheme(inspectionOrder: IInspectionOrder){
    const theme = inspectionOrder.theme;

    localStorage.setItem('theme', JSON.stringify(theme));
    localStorage.setItem('signatureFooter', inspectionOrder.signature_footer);
    localStorage.setItem('brandUrl', inspectionOrder.img_logo);
  }

  async getAppTheme(): Promise<ITheme | null> {
    const theme = localStorage.getItem('theme');
    if (!theme) return null;
    return JSON.parse(theme);
  }

  async setAppTheme(){
    const theme = await this.getAppTheme()
    if (!theme) return;
    document.documentElement.style.setProperty('--primary-color', theme.primary_color);
    document.documentElement.style.setProperty('--secondary-color', theme.secundary_color);
    document.documentElement.style.setProperty('--terciary-color', theme.terceary_color);
    document.documentElement.style.setProperty('--title-font-color', theme.title_font_color);
    document.documentElement.style.setProperty('--description-font-color', theme.description_font_color);
    document.documentElement.style.setProperty('--background-screen', theme.backgroundScreen);
    document.documentElement.style.setProperty('--background-card', theme.backgroundCard);
  }
}
